import Vue from 'vue'
import Vuex from 'vuex'
import atomic from "atomicjs"
import { isEarlySupporterPlan, isProPlan, hasProFeatures, isBizPlan, hasBizFeatures, isCurrentPlan } from "@/plans-settings"

function isEmptyOrSpaces(str) {
  return str === undefined || str === null || str.match(/^ *$/) !== null
}

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      isLoggedIn: false,
      email: null,
      app_metadata: {
        api_token: null,
        expires_at: null,
      },
      user_metadata: {},
      was_invited: false,
    },
    account: {
      id: null,
      name: "old",
      subscribed: false,
      subscription_plan_id: null,
      is_early_supporter: false,
      has_pro_plan: false,
      has_pro_features: false,
      has_biz_plan: false,
      has_biz_features: false,
      is_current_plan: false,
      past_due: false
    },
    availableAccounts: [],
    feedformPresets: {},
    feedformPresetsLoaded: false,
    userLoaded: false,
  },
  mutations: {

    SET_USER(state, user) {
      state.user = user
    },
    SET_ACCOUNT(state, account) {
      state.account.id = account.id
      state.account.name = account.name
      state.account.subscribed = account.subscribed
      state.account.subscription_plan_id = account.subscription_plan_id
      state.account.is_early_supporter = account.is_early_supporter
      state.account.has_pro_plan = account.has_pro_plan
      state.account.has_pro_features = account.has_pro_features
      state.account.has_biz_plan = account.has_biz_plan
      state.account.has_biz_features = account.has_biz_features
      state.account.is_current_plan = account.is_current_plan
      state.account.past_due = account.past_due
      state.account.is_owner = account.is_owner
    },

    SET_ACCOUNT_NAME(state, accountName) {
      state.account.name = accountName
      state.availableAccounts.forEach((account) => {
        if(account.id === state.account.id) {
          account.name = accountName
        }
      })
    },
    SET_ACCOUNT_ID(state, accountId) {
      state.account.id = accountId
    },

    SET_FEEDFORM_PRESETS(state, feedformPresets) {
      state.feedformPresets = feedformPresets
      state.feedformPresetsLoaded = true
    },
    SET_SUBSCRIBED(state, subscribed) {
      state.account.subscribed = subscribed
    },
    SET_PAST_DUE(state, pastDue) {
      state.account.past_due = pastDue
    },
    SET_MGM_URLS(state, user_data) {
      state.account.cancel_url = user_data.cancel_url
      state.account.update_url = user_data.update_url
    },
    SET_USER_LOADED(state, userLoaded) {
      state.userLoaded = userLoaded
    },
    SET_SUBSCRIPTION_PLAN_ATTRIBUTES(state, subscription_plan_id) {
      state.account.subscription_plan_id = subscription_plan_id
      state.account.is_early_supporter = isEarlySupporterPlan(subscription_plan_id)
      state.account.has_biz_plan = isBizPlan(subscription_plan_id)
      state.account.has_biz_features = hasBizFeatures(subscription_plan_id)
      state.account.has_pro_plan = isProPlan(subscription_plan_id)
      state.account.has_pro_features = state.account.has_biz_features || hasProFeatures(subscription_plan_id)

      state.account.is_current_plan = isCurrentPlan(subscription_plan_id)
    },
    SET_API_TOKEN(state, api_token_data) {
      state.user.app_metadata.api_token = api_token_data.auth_token
      state.user.app_metadata.expires_at = api_token_data.expires_at
    },
    SET_AVAILABLE_ACCOUNTS(state, accounts) {
      state.availableAccounts = accounts
    }
  },
  actions: {
    initialiseStore({ commit, dispatch }) {
      console.log("initialiseStore")
      return dispatch("setUserFromJWT")
    },
    login({ commit, dispatch }, user) {
      return atomic(process.env.API_HOST + "auth/login", {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        data: user,
      }).then(response => {
        localStorage.setItem("auth", JSON.stringify(response.data))
        return dispatch("setUserFromJWT")
      })
    },
    confirm({ commit, dispatch }, token) {
      return atomic(process.env.API_HOST + "auth/confirm", {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        data: { token: token },
      }).then(response => {
        localStorage.setItem("auth", JSON.stringify(response.data))
        return dispatch("setUserFromJWT")
      })
    },
    recover({ commit, dispatch }, token) {
      return atomic(process.env.API_HOST + "auth/recover", {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        data: { token: token },
      }).then(response => {
        localStorage.setItem("auth", JSON.stringify(response.data))
        return dispatch("setUserFromJWT")
      })
    },
    logout({ commit, dispatch }) {
      localStorage.removeItem("auth")
      localStorage.removeItem("account")

      commit('SET_USER', {
        isLoggedIn: false,
        email: null,
        app_metadata: {
          api_token: null,
          expires_at: null,
        },
        user_metadata: {},
        was_invited: false,
      })
      commit('SET_ACCOUNT',
      {
        id: null,
        name: "",
        subscribed: false,
        subscription_plan_id: null,
        is_early_supporter: false,
        has_pro_plan: false,
        has_pro_features: false,
        has_biz_plan: false,
        has_biz_features: false,
        is_current_plan: false,
        past_due: false
      })
      console.log("User logged out")
    },
    async changePassword({ commit, dispatch, state }, password) {
      await dispatch('getAPIToken')
      return atomic(process.env.API_HOST + "auth/change-password", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + state.user.app_metadata.api_token,
          "Content-type": "application/json",
        },
        data: { password: password },
      })
        .then(response => {
          dispatch("setUserFromJWT")
        })
    },
    async setUserFromJWT({ commit, dispatch, state }) {
      let authUser = JSON.parse(localStorage.getItem("auth"))

      if (state.userLoaded) {
        return
      }

      if (authUser == undefined || (isEmptyOrSpaces(authUser.auth_token) && isEmptyOrSpaces(authUser.expires_at) && isEmptyOrSpaces(authUser.refresh_token))) {
        return
      }
      //await commit('SET_API_TOKEN', {auth_token: authUser.auth_token, expires_at: authUser.expires_at}) //alternative bug fix option

      let user = {
        isLoggedIn: true,
        email: authUser.email,
        id: authUser.id,
        app_metadata: {
          api_token: authUser.auth_token,
          expires_at: authUser.expires_at,
        },
        user_metadata: {},
        was_invited: authUser.was_invited,
      }

      await commit('SET_USER', user)
      await dispatch('getAPIToken') // token is set in user with call before and then it's available here too
      return dispatch('getAPIToken').then(response => {
        console.log("getAPIToken ok, load loadAccountDetails")
        return dispatch('loadAccounts')
      }) 
    },
    updateFeedformPresets({ commit, dispatch }, userDetails) {
      commit("SET_FEEDFORM_PRESETS", userDetails.presets)
    },

    updateAccountName({ commit, dispatch }, name) {
      commit("SET_ACCOUNT_NAME", name)
    },

    async getAPIToken({ commit, dispatch, state }) {
      
      if (!isEmptyOrSpaces(state.user.app_metadata.api_token) && !isEmptyOrSpaces(String(state.user.app_metadata.expires_at))) {
        // js date uses ms, api uses seconds
        if (new Date() < (state.user.app_metadata.expires_at * 1000)) {
          return state.user.app_metadata.api_token
        } else {
          let authUser = JSON.parse(localStorage.getItem("auth"))
          let tuser = null
          try {
            tuser = await atomic(process.env.API_HOST + "auth/token", {
              method: "POST",
              headers: {
                "Content-type": "application/json",
              },
              data: { token: authUser.refresh_token },
            })
            .then(async response => {
              localStorage.setItem("auth", JSON.stringify(response.data))
              return response.data
              
            }).catch(error => {
              console.log(error)
              throw new Error(`API ${error}`)
            })
          } catch (error) {
            console.log("catch", error)
            throw error
          }
            console.log("getAPIToken", tuser)
            await commit('SET_API_TOKEN', tuser)
            console.log(state.user.app_metadata)
            return state.user.app_metadata.api_token
        }
      }
      console.log("getAPIToken fallback", state.user.app_metadata)
      return state.user.app_metadata.api_token
    },
    async selectAccount({ commit, dispatch, state }, accountId) {

      let findIndex = state.availableAccounts.findIndex((acc) => acc.id === accountId)
      if (findIndex > -1) {
        localStorage.setItem("account", state.availableAccounts[findIndex].id)
        await commit("SET_ACCOUNT_ID", accountId)
      }
    },
    async loadAccounts({ commit, dispatch, state }) {

      if (state.user.app_metadata.api_token === null) {
        console.log("loadAccounts getAPIToken")
        await dispatch('getAPIToken')
      }

      return atomic(process.env.API_HOST + "accounts", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + state.user.app_metadata.api_token,
          "Content-type": "application/json",
        },
      })
        .then(async function (response) {
          let accounts = response.data;
          await commit('SET_AVAILABLE_ACCOUNTS', accounts)
          console.log("yyyy", accounts)

          if(accounts.length > 0) {
            let accountId = localStorage.getItem("account")
            console.log("loadAccounts", accountId, new Date())
            if (accountId) {
              let findIndex = accounts.findIndex((acc) => acc.id === accountId)
              console.log("loadAccounts", accountId, findIndex)
              if (findIndex > -1) {
                await commit("SET_ACCOUNT", accounts[findIndex])
                if (accounts[findIndex].subscribed === true || accounts[findIndex].past_due === true) {
                  await commit("SET_SUBSCRIPTION_PLAN_ATTRIBUTES", accounts[findIndex].subscription_plan_id)
                }
              }
            } else {
              console.log("loadAccounts else", accountId)
              await commit("SET_ACCOUNT", accounts[accounts.length - 1])
              if (accounts[accounts.length - 1].subscribed === true || accounts[accounts.length - 1].past_due === true) {
                await commit("SET_SUBSCRIPTION_PLAN_ATTRIBUTES", accounts[accounts.length - 1].subscription_plan_id)
              }
            } 

            return dispatch('loadAccountDetails')
          }
          return accounts
        }).catch(function (error) {
          console.log(error)
          console.log(error.status) // xhr.status
          console.log(error.statusText) // xhr.statusText
          throw new Error(`API ${error}`)
        })
      },
    async loadAccountDetails({ commit, dispatch, state }) {

      if (state.user.app_metadata.api_token === null) {
        console.log("loadAccountDetails getAPIToken")
        await dispatch('getAPIToken')
      }

      return atomic(process.env.API_HOST + "account/" + state.account.id, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + state.user.app_metadata.api_token,
          "Content-type": "application/json",
        },
      })
        .then(async function (response) {
          //console.log(response.data)
          await commit("SET_USER_LOADED", true)
          return commit("SET_FEEDFORM_PRESETS", response.data.presets)

          //console.log(response.data); // xhr.responseText
          //console.log(response.xhr); // full response
        })
        .catch(function (error) {
          console.log(error)
          console.log(error.status) // xhr.status
          console.log(error.statusText) // xhr.statusText
          throw new Error(`API ${error}`)
        })
    }
  },
  modules: {
  }
})
